import { fromJS } from 'immutable';

export const VOLCANO_EVENT_SEARCH_TOGGLE_VOL_PARAMS = 'VOLCANO_EVENT_SEARCH_TOGGLE_VOL_PARAMS';
export const VOLCANO_EVENT_SEARCH_TOGGLE_VOL_EFFECTS = 'VOLCANO_EVENT_SEARCH_TOGGLE_VOL_EFFECTS';
export const VOLCANO_EVENT_SEARCH_TOGGLE_HAZ_ASSOC = 'VOLCANO_EVENT_SEARCH_TOGGLE_HAZ_ASSOC';

const initialState = fromJS({
  volcanoParametersExpanded: true,
  volcanoEffectsExpanded: false,
  hazardAssociationExpanded: false,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const volcanoEventSearchPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case VOLCANO_EVENT_SEARCH_TOGGLE_VOL_PARAMS:
      return state.update('volcanoParametersExpanded', expanded => !expanded);
    case VOLCANO_EVENT_SEARCH_TOGGLE_VOL_EFFECTS:
      return state.update('volcanoEffectsExpanded', expanded => !expanded);
    case VOLCANO_EVENT_SEARCH_TOGGLE_HAZ_ASSOC:
      return state.update('hazardAssociationExpanded', expanded => !expanded);
    default:
      return state;
  }
};
